<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Salary Grade Scale</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_number"> <span class="required">*</span> Grade Number </label>
                        <input
                            class="form-control invoice-edit-input"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.grade_number"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_title"> Grade Title </label>
                        <input
                            class="form-control invoice-edit-input"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.grade_title"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label" for="grade_title"> Description </label>
                        <input
                            class="form-control invoice-edit-input"
                            tabindex="1"
                            type="text"
                            placeholder=""
                            v-model="formData.description"
                        >
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="mb-1">
                        <label class="form-label">
                          <span class="required">*</span> Scale Amount
                        </label>

                        <div v-for="(amount, index) in formData.scale_amount_data" :key="index" class="d-flex mb-1 align-items-center">
                          <input
                              class="form-control invoice-edit-input me-2"
                              type="number"
                              step="any"
                              v-model="formData.scale_amount_data[index]"
                              placeholder="Scale Amount"
                          />
                        </div>

                        <div v-for="(amount, index) in formData.scale_amount" :key="index" class="d-flex mb-1 align-items-center">
                          <input
                              class="form-control invoice-edit-input me-2"
                              type="number"
                              step="any"
                              v-model="formData.scale_amount[index]"
                              placeholder="Scale Amount"
                          />
                          <button
                              type="button"
                              class="btn btn-success btn-sm me-1"
                              @click="addScaleAmount"
                              v-if="index === formData.scale_amount.length - 1"
                          >
                            <i class="fas fa-plus"></i>
                          </button>

                          <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              @click="removeScaleAmount(index)"
                              v-if="formData.scale_amount.length > 1"
                          >
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="col-6 text-center mb-2 mt-2">
                      <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        Submit
                      </button>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import { inject, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';

const props = defineProps({
    formData:{
      type:Object,
      default:{}
    },
});

const emit = defineEmits(['submitted']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const loader = ref(false);
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const {
  fetchTypes,
  createSalaryGradeScale
} = handleHrPayroll()

const submit = async() => {
    const query = getQuery();
    loading.value = true;
    await storeData(query)
}

const addScaleAmount = () => {
  props.formData.scale_amount.push('')
}

const removeScaleAmount = (index) => {
  props.formData.scale_amount.splice(index, 1)
}

const storeData = async (query) => {
  let salaryGradeScaleData = {};
  salaryGradeScaleData.company_id = $route.params.companyId;
  salaryGradeScaleData.grade_number = props.formData.grade_number;
  salaryGradeScaleData.grade_title = props.formData.grade_title;
  salaryGradeScaleData.description = props.formData.description;
  salaryGradeScaleData.scale_amount = props.formData.scale_amount;
  salaryGradeScaleData.scale_amount_data = props.formData.scale_amount_data || [];
  salaryGradeScaleData.grade_serial = props.formData.grade_serial || null;

  await createSalaryGradeScale(salaryGradeScaleData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit("submitted");
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const onClickClose = () => {
  props.formData.grade_serial = null;
  props.formData.grade_number = null;
  props.formData.grade_title = null;
  props.formData.description = null;
  props.formData.scale_amount = [''];
  props.formData.scale_amount_data = [];
  props.initialScaleCount = 0;
  $store.state.isModalOpenTwo = false;
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}
</script>
